export default __webpack_public_path__ + "static/media/13.6e19ebcc.jpg";